export const POST_TRUCK_HELP = `https://www.youtube.com/watch?v=bogX6Q8VsrI`;
export const LOAD_SEARCH_HELP = `https://www.youtube.com/embed/fe2KowqyEII?mute=1&autoplay=0&controls=1&disablekb=0&loop=0&modestbranding=1&showinfo=0&rel=0`;
export const LOAD_INTRODUCTION = `https://vimeo.com/383207316`;
export const NOTIFICATION_TIP = `https://www.youtube.com/embed/JfBupYngPHk?mute=1&amp;autoplay=0&amp;controls=1&amp;disablekb=0&amp;loop=0&amp;modestbranding=1&amp;showinfo=0&amp;rel=0`;
export const HAULPAY_HELP_BLOG = `https://haulpay.io/blog/category/tips-and-faq/`;
export const HAULPAY_DEMO = `https://youtu.be/Aykn5XgennU`;
